import { ConfigBuilder, installEmpathyX } from '@empathybroker/ebx-gluon';
import App from './App.vue';
import CdlBackgroundClose from './components/cdl-background-close.vue';
import * as Config from './config';
import { ADAPTER_CONFIG } from './config/adapter.config';
import { useEmpathyAdapter } from './config/adapter.configurator';
import { rebindContainer } from './config/configurator/rebind-container.configurator';
import { registerComponents } from './config/configurator/register-components.configurator';
import { WIRING_CONFIG } from './config/wiring.config';
import { DESKTOP_LOCALE_CONFIG } from './i18n/desktop/locale.config';
import { MOBILE_LOCALE_CONFIG } from './i18n/mobile/locale.config';

installEmpathyX(appBuilder => {
  appBuilder
    .setAppComponent(App)
    .setPhantomComponentsConfig(Config.PHANTOM_CONFIG)
    .setAdapterFactory(useEmpathyAdapter(ADAPTER_CONFIG))
    .setCustomConfigurator(configuratorOptions => {
      registerComponents();
      rebindContainer(configuratorOptions);
    })
    .setDevicesDetectionConfig({ screenWidth: { mobile: 1024 } })
    .setDynamicConfig(Config.DYNAMIC_CONFIG)
    .addSubConfig(WIRING_CONFIG)
    .addPortal(CdlBackgroundClose, '#ebx-external-background-close')
    .setConfigFor('mobile', (configBuilder: ConfigBuilder) => {
      configBuilder
        .setUserServiceStorageConfig(Config.MOBILE_USER_SERVICE_STORAGE_CONFIG)
        .setLocaleConfig(MOBILE_LOCALE_CONFIG)
        .setCoreConfig(Config.MOBILE_CORE)
        .setOpenConfig(Config.MOBILE_OPEN)
        .setCloseConfig(Config.MOBILE_CLOSE)
        .setSearchBoxConfig(Config.MOBILE_SEARCH_BOX)
        .setScrollConfig(Config.MOBILE_SCROLL)
        .setEmpathizeConfig(Config.MOBILE_EMPATHIZE)
        .setBannersConfig(Config.MOBILE_BANNERS)
        .setPopularSearchesConfig(Config.MOBILE_POPULAR_SEARCHES)
        .setSuggestionsConfig(Config.MOBILE_TERM_SUGGESTIONS)
        .setHistoryConfig(Config.MOBILE_HISTORY)
        .setResultsConfig(Config.MOBILE_DEFAULT_RESULT)
        .setResultsConfig(Config.MOBILE_IDENTIFIER_RESULT, 'identifierSuggestions')
        .setResultsConfig(Config.MOBILE_SUGGESTIONS_RESULT, 'resultsSuggestions')
        .setResultsConfig(Config.MOBILE_NEXT_QUERY_PARTIALS_RESULT, 'nextQueries')
        .setResultsConfig(Config.MOBILE_NEXT_QUERY_PARTIALS_RESULT, 'partials')
        .setResultsSuggestionsConfig(Config.MOBILE_RESULTS_SUGGESTIONS)
        .setResultsGridConfig(Config.MOBILE_RESULTS)
        .setRecommendationsConfig(Config.MOBILE_RECOMMENDATIONS)
        .setSortConfig(Config.MOBILE_SORT)
        .setFacetsConfig(Config.DEFAULT_MOBILE_FACETS)
        .setNextQueriesConfig(Config.MOBILE_NEXT_QUERIES)
        .setNextQueriesSuggestionsConfig(Config.MOBILE_NEXT_QUERY_SUGGESTIONS)
        .setPartialsConfig(Config.MOBILE_PARTIALS)
        .setIdentifierSuggestionsConfig(Config.MOBILE_IDENTIFIER_SUGGESTIONS)
        .setTrackAddToCartConfig(Config.MOBILE_TRACK_ADD_TO_CART)
        .setTrackQueryConfig(Config.MOBILE_TRACK_QUERY);
    })
    .setConfigFor('desktop', (configBuilder: ConfigBuilder) => {
      configBuilder
        .setSortConfig(Config.DESKTOP_SORT)
        .setLocaleConfig(DESKTOP_LOCALE_CONFIG)
        .setCoreConfig(Config.DESKTOP_CORE)
        .setSearchBoxConfig(Config.DESKTOP_SEARCH_BOX)
        .setScrollConfig(Config.DESKTOP_SCROLL)
        .setFacetsConfig(Config.DEFAULT_DESKTOP_FACETS)
        .setResultsGridConfig(Config.DESKTOP_RESULTS)
        .setResultsConfig(Config.DESKTOP_DEFAULT_RESULT)
        .setResultsConfig(Config.DESKTOP_DEFAULT_RESULT, 'nextQueries')
        .setResultsConfig(Config.DESKTOP_DEFAULT_RESULT, 'partials')
        .setResultsConfig(Config.DESKTOP_IDENTIFIER_RESULT, 'identifierSuggestions')
        .setRecommendationsConfig(Config.DESKTOP_RECOMMENDATIONS)
        .setNextQueriesConfig(Config.DESKTOP_NEXT_QUERIES);
    });
});
